module.exports = __webpack_public_path__ + "assets/img/yiyuan.87b9d103.png";